import { PHONE, locationSchema } from "../structured-data-core";

export function getFortWorthStructuredData() {
  const url = "https://restorehair.com/locations/texas/fort-worth/";
  const description =
    "Find out about your hair transplant options in Fort Worth with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Fort Worth", "1751 River Run, Suite 200", "Fort Worth", "TX", PHONE, url, description),
  ];
}
